import { useQuery } from '@tanstack/react-query';

import { callGetCompetitionTeamByInvite } from '@app/client/resources/competitions';

export function useQueryTeamByInviteCode({
    inviteCode,
    disabled,
    onError,
}: {
    inviteCode: string;
    disabled?: boolean;
    onError?: (err: string) => void;
}) {
    return useQuery(
        ['teams', 'query-by-invite', inviteCode],
        ({ signal }) =>
            callGetCompetitionTeamByInvite({ inviteCode, settings: { signal } }).then((res) => {
                if (!res.ok && res.error?.detail) {
                    onError?.(res.error?.detail || 'Error getting invite team');
                }
                return res;
            }),
        {
            enabled: !disabled,
            keepPreviousData: true,
            retry: false,
            select: (res) => (res.ok ? res.value : undefined),
        },
    );
}
